import type { HttpErrorResponse } from '@angular/common/http';

import { createSelector } from '@ngrx/store';

import { createSingleEntityStore, ngrxEvent, pipeState } from '@core/ngrx-legacy';
import type { AddOrgPayload, NewOrgResponse, Org, OrgDeletionStatus } from '@core/tellent-types';

import type { DeleteOrgPayload } from '../types';
import { EntityStoreKey } from '../types';

const { actions, selectors, reducer, namespace } = createSingleEntityStore<Org>()(
  EntityStoreKey.TellentOrganization,
  {
    customActions: adapter => ({
      deleteOrg: (state, payload: DeleteOrgPayload) => adapter.markAsPending(state),
      deleteOrgSuccess: (state, payload: Org) =>
        pipeState(adapter.update(state, payload), next => adapter.markAsLoaded(next)),
      deleteOrgFail: ngrxEvent<HttpErrorResponse>(),
      deletionStatus: ngrxEvent<void>(),
      deletionStatusSuccess: (state, payload: OrgDeletionStatus) =>
        pipeState(
          pipeState(adapter.update(state, { deletionStatus: payload }), next =>
            adapter.markAsLoaded(next),
          ),
        ),
      deletionStatusFail: ngrxEvent<void>(),

      addOrg: (state, payload: AddOrgPayload) => adapter.markAsPending(state),
      addOrgSuccess: (state, payload: NewOrgResponse) =>
        pipeState(adapter.update(state, payload), next => adapter.markAsLoaded(next)),
      addOrgFail: ngrxEvent<HttpErrorResponse>(),
    }),
  },
);

const selectDeletionStatus = createSelector(selectors.data, data => data?.deletionStatus);

const TellentOrganizationSelectors = {
  ...selectors,
  selectDeletionStatus,
};

export {
  TellentOrganizationSelectors,
  actions as TellentOrganizationActions,
  reducer as TellentOrganizationReducer,
  namespace as TellentOrganizationNamespace,
};
